const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
export const types = {
  // CONTRACTS AND PERMANENCE
  GET_LIST_CONTRACTS_BEGINS: 'GET_LIST_CONTRACTS_BEGINS',
  GET_LIST_CONTRACTS_SUCCESS: 'GET_LIST_CONTRACTS_SUCCESS',
  GET_LIST_CONTRACTS_FAILURE: 'GET_LIST_CONTRACTS_FAILURE',
  GET_LIST_CONTRACTS_BY_ID_BEGINS: 'GET_LIST_CONTRACTS_BY_ID_BEGINS',
  GET_LIST_CONTRACTS_BY_ID_SUCCESS: 'GET_LIST_CONTRACTS_BY_ID_SUCCESS',
  GET_LIST_CONTRACTS_BY_ID_FAILURE: 'GET_LIST_CONTRACTS_BY_ID_FAILURE',
};

export const initialState = {
  // CONTRACTS AND PERMANENCE
  listContracts: null,
  listPermanences: null,
  listContractsFetching: false,
  listContractsError: false,
  listContractsAlreadyFetched: false,

  listContractsById: {},
  listContractsByIdFetching: false,
  listContractsByIdError: false,
};

const ContractsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case HYDRATE: {
      const { contracts } = payload;
      return {
        ...state,
        ...contracts,
      };
    }
    case types.GET_LIST_CONTRACTS_BEGINS:
      return {
        ...state,
        listContractsFetching: true,
        listContractsError: null,
      };
    case types.GET_LIST_CONTRACTS_SUCCESS: {
      const { productos, listPermanences } = payload;
      return {
        ...state,
        listContracts: productos,
        listPermanences,
        listContractsFetching: false,
        listContractsError: false,
        listContractsAlreadyFetched: true,
      };
    }
    case types.GET_LIST_CONTRACTS_FAILURE:
      return {
        ...state,
        listContractsFetching: false,
        listContractsError: payload,
      };
    case types.GET_LIST_CONTRACTS_BY_ID_BEGINS:
      return {
        ...state,
        listContractsByIdFetching: true,
        listContractsByIdError: null,
      };
    case types.GET_LIST_CONTRACTS_BY_ID_SUCCESS: {
      let newListContractsById = state.listContractsById;
      if (payload) {
        newListContractsById = {
          ...state.listContractsById,
          [payload.id]: payload.data,
        };
      }
      return {
        ...state,
        listContractsById: newListContractsById,
        listContractsByIdFetching: false,
        listContractsByIdError: false,
      };
    }
    case types.GET_LIST_CONTRACTS_BY_ID_FAILURE:
      return {
        ...state,
        listContractsByIdFetching: false,
        listContractsByIdError: payload,
      };
    default:
      return state;
  }
};

export const actions = {
  // Actions for contracts
  getListContracts: () => ({ type: types.GET_LIST_CONTRACTS_BEGINS }),
  successGetListContracts: (data) => ({
    type: types.GET_LIST_CONTRACTS_SUCCESS,
    payload: data,
  }),
  failureGetListContracts: (error) => ({
    type: types.GET_LIST_CONTRACTS_FAILURE,
    payload: error,
  }),
  getListContractsById: (productId) => ({
    type: types.GET_LIST_CONTRACTS_BY_ID_BEGINS,
    productId,
  }),
  successGetListContractsById: (data) => ({
    type: types.GET_LIST_CONTRACTS_BY_ID_SUCCESS,
    payload: data,
  }),
  failureGetListContractsById: (error) => ({
    type: types.GET_LIST_CONTRACTS_BY_ID_FAILURE,
    payload: error,
  }),
};

export default ContractsReducers;
